import type { StandardSchemaV1 } from '@standard-schema/spec';
import type { Resolver } from 'react-hook-form';
import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';

// Zod v4's Standard Schema types the input as `unknown` instead of `FieldValues`,
// causing type errors with react-hook-form's standardSchemaResolver.
// See: https://github.com/react-hook-form/resolvers/issues/813
// biome-ignore lint/suspicious/noExplicitAny: required to bridge zod v4 + react-hook-form type gap
export const zodResolver = (schema: StandardSchemaV1<any, any>): Resolver<any> => {
  return standardSchemaResolver(schema);
};
